<template>
  <section class="deals-section">
    <div class="deals-section__container">
      <div class="section-header">
        <h2 class="section-header__title">BEST DEALS</h2>
        <div class="section-header__line"></div>
        <a href="/deals/" class="section-header__link">SEE ALL</a>
      </div>

      <div v-if="dealArticles.length > 0" class="deals-grid">
        <article
          v-for="article in dealArticles"
          :key="article.slug"
          class="deal-card"
        >
          <a :href="`/${article.category}/${article.slug}/`" class="deal-card__link">
            <div class="deal-card__image">
              <img v-if="article.featuredImage || article.image" :src="article.featuredImage || article.image" :alt="article.title" />
              <div v-if="article.discount" class="deal-card__badge">
                -{{ article.discount }}%
              </div>
            </div>
            <div class="deal-card__content">
              <span class="deal-card__tag">{{ article.subcategory || 'DEAL' }}</span>
              <h3 class="deal-card__title">{{ article.title }}</h3>
              <div v-if="article.price" class="deal-card__price-row">
                <span v-if="article.originalPrice" class="deal-card__old-price">
                  ${{ article.originalPrice }}
                </span>
                <span class="deal-card__new-price">${{ article.price }}</span>
              </div>
            </div>
          </a>
        </article>
      </div>
      <div v-else class="empty-state">
        <p>NO DEALS DETECTED.</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'DealsSection',
  computed: {
    dealArticles() {
      const articles = this.$store.getters['articles/getArticlesByCategory']('deals')
      return articles ? articles.slice(0, 4) : []
    },
  },
}
</script>

<style lang="scss" scoped>
.deals-section {
  padding: rem(48) 0;
  background: $bg-secondary;
  border-top: 2px solid $border-color;
  border-bottom: 2px solid $border-color;
}

.deals-section__container {
  max-width: $container-max-width;
  margin: 0 auto;
  padding: 0 rem(24);
}

.section-header {
  display: flex;
  align-items: center;
  gap: rem(24);
  margin-bottom: rem(48);

  &__title {
    font-size: rem(32);
    color: $text-primary;
    font-weight: 900;
    font-family: $font-family-heading;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin: 0;
  }

  &__line {
    flex: 1;
    height: 2px;
    background-color: $border-color;
  }

  &__link {
    color: $primary-color;
    font-family: $font-family-heading;
    font-size: rem(16);
    font-weight: 900;
    text-transform: uppercase;
    text-decoration: none;
    letter-spacing: 1px;
    transition: color $transition-speed;

    &:hover {
      color: $text-primary;
    }
  }
}

.deals-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: rem(24);

  @include pc {
    grid-template-columns: repeat(4, 1fr);
    gap: rem(24);
  }
}

.deal-card {
  background: $bg-primary;
  border: 1px solid $border-color;
  display: flex;
  flex-direction: column;
  position: relative;
  @include brutal-hover;

  &__link {
    display: flex;
    flex-direction: column;
    height: 100%;
    text-decoration: none;
    color: inherit;
  }

  &__image {
    position: relative;
    width: 100%;
    height: rem(200);
    overflow: hidden;
    border-bottom: 1px solid $border-color;
    background: #111;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.3s;
    }
  }

  &:hover &__image img {
    transform: scale(1.05);
  }

  &__badge {
    position: absolute;
    top: rem(12);
    right: rem(12);
    background: $primary-color;
    color: #fff;
    padding: rem(4) rem(8);
    font-size: rem(16);
    font-weight: 900;
    font-family: $font-family-heading;
    letter-spacing: 1px;
    border: 1px solid $bg-primary;
  }

  &__content {
    padding: rem(20);
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  &__tag {
    color: $secondary-color;
    font-size: rem(12);
    font-weight: 900;
    font-family: $font-family-heading;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-bottom: rem(12);
  }

  &__title {
    font-size: rem(20);
    color: $text-primary;
    margin: 0 0 rem(16) 0;
    line-height: 1.2;
    font-family: $font-family-heading;
    font-weight: 900;
    text-transform: uppercase;
  }

  &__price-row {
    display: flex;
    align-items: center;
    gap: rem(12);
    margin-top: auto;
    padding-top: rem(16);
    border-top: 1px solid $border-color;
  }

  &__old-price {
    font-size: rem(16);
    color: $text-muted;
    text-decoration: line-through;
    font-weight: 700;
  }

  &__new-price {
    font-size: rem(24);
    color: $primary-color;
    font-weight: 900;
    font-family: $font-family-heading;
  }
}

.empty-state {
  text-align: center;
  padding: rem(64);
  font-family: $font-family-heading;
  font-weight: 900;
  font-size: rem(24);
  color: $text-muted;
  border: 2px dashed $border-color;
  text-transform: uppercase;
}
</style>
